import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'
import styled from 'styled-components'
import {
    Modal,
    Switch,
    Form,
    Radio,
    Input,
    Button,
    Dropdown,
    Menu,
    Select,
    Space,
    Upload,
    Image,
    message
} from 'antd'
import {
    EllipsisOutlined,
    EditOutlined,
    DeleteOutlined,
    UploadOutlined
} from '@ant-design/icons'
import { uploadImage, getCategoryUrl } from '../../../services/apiServices'
import RowLayout from './../../RowLayout/RowLayout'
import LoadingModal from '../../Modal/Loading'
import IconSelector from './../../IconSelector/IconSelector'
import TagEditorModal from './TagEditorModal'
import CategorySelectorModal from './../CategorySelectorModal/CategorySelectorModal'

const { Option } = Select

const SUBMENU_STYLES = [
    { key: 1, name: 'Drop-down' },
    { key: 2, name: 'Mega' }
]

const Container = styled.div`
    .image-wrapper {
        display: inline-block;
        padding: 20px;
        margin-top: 15px;
        border: 1px dashed #ccc;
        > img {
            max-width: 100%;
        }
    }
`

class MenuSettingModal extends Component {
    initialState = {
        type: 'ADD',
        isLoading: false,
        menu: {},
        icon: '',
        isOpenTagEditorModal: false,
        isOpenTagColorPicker: false,
        tagTitle: '',
        tagColor: '',
        tagAnimation: 'none',
        parentMenu: '-1',
        submenuStyle: 1,
        submenuBackgroundImage: '',
        selectedCategoryType: 'POST',
        isOpenCategoryUrlModal: false
    }

    state = this.initialState

    formRef = React.createRef()

    UNSAFE_componentWillReceiveProps(nextProps, prevState) {
        if (!prevState.isOpen && nextProps.isOpen) {
            let state = this.initialState
            if (!isEmpty(nextProps.menu)) {
                state = {
                    ...state,
                    type: 'EDIT',
                    menu: nextProps.menu,
                    icon: nextProps.menu.icon,
                    tagTitle: nextProps.menu.tag_title,
                    tagColor: nextProps.menu.tag_color,
                    tagAnimation: nextProps.menu.tag_effect,
                    submenuStyle: nextProps.menu.submenu_style || 1,
                    submenuBackgroundImage: nextProps.menu.background_url
                }
            } else if (nextProps.selectedMenuIndexList.length > 0) {
                state = {
                    ...state,
                    parentMenu: nextProps.selectedMenuIndexList.join(',')
                }
            }
            this.setState(state)
        }
    }

    onChangeIcon(icon) {
        this.setState({
            icon
        })
    }

    toggleTagEditorModal(status) {
        this.setState({
            isOpenTagEditorModal: status
        })
    }

    onSubmitTag(value) {
        this.setState({
            isOpenTagEditorModal: false,
            tagTitle: value.text,
            tagColor: value.color,
            tagAnimation: value.animation
        })
    }

    onRemoveTag() {
        this.setState({
            tagTitle: '',
            tagColor: 'none',
            tagAnimation: 'none'
        })
    }

    async uploadImage(file) {
        this.setState({ isLoading: true })
        try {
            let { image } = await uploadImage({ body: { file } })
            this.setState({ isLoading: false, submenuBackgroundImage: image })
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async getCategoryUrl(catId, onSuccess) {
        this.setState({ isLoading: true })
        try {
            let { url } = await getCategoryUrl({ body: { id: catId } })
            this.setState({
                isLoading: false
            })
            onSuccess && onSuccess(url)
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    onChangeSubmenuBackgroundImage(e) {
        this.uploadImage(e.file.originFileObj)
    }

    onRemoveSubmenuBackgroundImage() {
        this.setState({ submenuBackgroundImage: '' })
    }

    onChangeParentMenu(key) {
        this.setState({
            parentMenu: key
        })
    }

    onChangeSubmenuStyle(style) {
        this.setState({
            submenuStyle: style
        })
    }

    onSubmitCategoryUrl(catId) {
        this.onToggleCategoryUrlModal(false)
        this.getCategoryUrl(catId, url => {
            url = decodeURIComponent(url)
            this.formRef.current.setFieldsValue({
                url
            })
        })
    }

    onSubmit() {
        this.formRef.current
            .validateFields()
            .then(values => {
                this.formRef.current.resetFields()
                const data = {
                    type: this.state.type,
                    url: values.url,
                    title: values.title,
                    isNewTab: values.isNewTab,
                    icon: this.state.icon,
                    tagTitle: this.state.tagTitle,
                    tagColor: this.state.tagColor,
                    tagAnimation: this.state.tagAnimation,
                    submenuStyle: this.state.submenuStyle,
                    submenuBackgroundImage: this.state.submenuBackgroundImage,
                    parentMenu: this.state.parentMenu
                }
                this.props.onSubmit && this.props.onSubmit(data)
            })
            .catch(info => {
                console.log('Validate Failed:', info)
            })
    }

    onToggleCategoryUrlModal(status) {
        this.setState({
            isOpenCategoryUrlModal: status
        })
    }

    onSelectGenerateUrl(type) {
        this.setState(
            {
                selectedCategoryType: type
            },
            () => {
                this.onToggleCategoryUrlModal(true)
            }
        )
    }

    render() {
        let { T, isOpen, menuList, selectedMenuIndexList, onClose } = this.props

        let menuListOptions = generateParentMenuList(T, menuList)
        let parentMenuKey = generateParentMenuKey(selectedMenuIndexList)

        return (
            <Modal
                title={
                    this.state.type == 'ADD'
                        ? this.props.selectedMenuIndexList.length > 0
                            ? T('ADD_SUBMENU')
                            : T('ADD_MENU')
                        : T('EDIT_MENU')
                }
                width={640}
                centered
                destroyOnClose
                visible={isOpen}
                okText={T('OK')}
                cancelText={T('CANCEL')}
                onOk={this.onSubmit.bind(this)}
                onCancel={() => onClose()}>
                <Container>
                    <Form
                        ref={this.formRef}
                        name="control-ref"
                        initialValues={{
                            url: this.state.menu.url || '',
                            title: this.state.menu.title || '',
                            isNewTab: !!this.state.menu.is_new_tab
                        }}>
                        <RowLayout title={T('TEXT')} contentSpan={14}>
                            <Form.Item
                                name="title"
                                rules={[
                                    {
                                        required: true,
                                        message: T('FORM_ERR_REQUIRE')
                                    }
                                ]}>
                                <Input />
                            </Form.Item>
                        </RowLayout>
                        <RowLayout title={T('URL')} contentSpan={14}>
                            <Form.Item name="url" value="dsdsd">
                                <Input
                                    value={this.state.menu.url || 'dd'}
                                    placeholder={
                                        'e.g. https://www.indytheme.com'
                                    }
                                    addonAfter={
                                        <Dropdown
                                            overlay={linkGenerateMenu(
                                                T,
                                                this.onSelectGenerateUrl.bind(
                                                    this
                                                )
                                            )}
                                            placement="bottomCenter">
                                            <EllipsisOutlined className="pointer" />
                                        </Dropdown>
                                    }
                                />
                            </Form.Item>
                        </RowLayout>
                        <RowLayout title={T('ICON')} contentSpan={16}>
                            <IconSelector
                                T={T}
                                selectedIcon={this.state.icon}
                                onSelect={this.onChangeIcon.bind(this)}
                            />
                        </RowLayout>
                        <RowLayout
                            title={T('TAG')}
                            contentSpan={14}
                            marginBottom={24}>
                            <Space>
                                {this.state.tagTitle && (
                                    <div
                                        style={{
                                            display: 'inline-block',
                                            marginRight: 12
                                        }}>
                                        <div
                                            className={`menutypetag menutypetag--${this.state.tagColor} animated infinite ${this.state.tagAnimation}`}>
                                            {this.state.tagTitle}
                                        </div>
                                    </div>
                                )}

                                <Button
                                    type="primary"
                                    onClick={() =>
                                        this.toggleTagEditorModal(true)
                                    }>
                                    <EditOutlined /> {T('EDIT')}
                                </Button>

                                {this.state.tagTitle && (
                                    <Button
                                        type="primary"
                                        danger
                                        icon={<DeleteOutlined />}
                                        onClick={this.onRemoveTag.bind(
                                            this
                                        )}></Button>
                                )}
                            </Space>

                            <TagEditorModal
                                T={T}
                                isOpen={this.state.isOpenTagEditorModal}
                                text={this.state.tagTitle}
                                color={this.state.tagColor}
                                animation={this.state.tagAnimation}
                                onSubmit={this.onSubmitTag.bind(this)}
                                onClose={() => this.toggleTagEditorModal(false)}
                            />
                        </RowLayout>
                        <RowLayout title={T('OPEN_NEW_TAB')}>
                            <Form.Item name="isNewTab" valuePropName="checked">
                                <Switch />
                            </Form.Item>
                        </RowLayout>
                        <RowLayout
                            title={T('PARENT_MENU')}
                            contentSpan={14}
                            marginBottom={24}>
                            <Select
                                disabled={this.state.type == 'EDIT'}
                                disabled={
                                    this.props.selectedMenuIndexList.length > 0
                                }
                                value={
                                    this.state.type == 'ADD'
                                        ? this.state.parentMenu
                                        : parentMenuKey
                                }
                                style={{ width: 200 }}
                                onChange={this.onChangeParentMenu.bind(this)}>
                                {menuListOptions.map((item, index) => (
                                    <Option key={index} value={item.index}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </RowLayout>
                        {((this.state.type == 'EDIT' &&
                            selectedMenuIndexList.length <= 1) ||
                            (this.state.type == 'ADD' &&
                                this.state.parentMenu == '-1')) && (
                            <>
                                <RowLayout
                                    title={T('SUBMENU_STYLE')}
                                    contentSpan={14}
                                    marginBottom={24}>
                                    <Select
                                        value={this.state.submenuStyle}
                                        style={{ width: 200 }}
                                        onChange={this.onChangeSubmenuStyle.bind(
                                            this
                                        )}>
                                        {SUBMENU_STYLES.map(item => (
                                            <Option
                                                key={item.key}
                                                value={item.key}>
                                                {item.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </RowLayout>

                                {this.state.submenuStyle == 2 && (
                                    <RowLayout
                                        title={T('SUBMENU_BACKGROUND_IMAGE')}
                                        contentSpan={14}>
                                        <Space>
                                            <Upload
                                                accept="image/gif, image/jpeg, image/png, image/webp"
                                                fileList={[]}
                                                customRequest={() => {}}
                                                onChange={e =>
                                                    this.onChangeSubmenuBackgroundImage(
                                                        e
                                                    )
                                                }>
                                                <Button type="primary">
                                                    <UploadOutlined />{' '}
                                                    {T('UPLOAD')}
                                                </Button>
                                            </Upload>
                                            {this.state
                                                .submenuBackgroundImage && (
                                                <Button
                                                    type="primary"
                                                    danger
                                                    icon={<DeleteOutlined />}
                                                    onClick={this.onRemoveSubmenuBackgroundImage.bind(
                                                        this
                                                    )}></Button>
                                            )}
                                        </Space>
                                        {this.state.submenuBackgroundImage && (
                                            <div>
                                                <div className="image-wrapper">
                                                    <Image
                                                        key={
                                                            this.state
                                                                .submenuBackgroundImage
                                                        }
                                                        src={
                                                            this.state
                                                                .submenuBackgroundImage
                                                        }
                                                        alt={T(
                                                            'SUBMENU_BACKGROUND_IMAGE'
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </RowLayout>
                                )}
                            </>
                        )}
                    </Form>
                </Container>

                <CategorySelectorModal
                    T={T}
                    categoryType={this.state.selectedCategoryType}
                    isOpenModal={this.state.isOpenCategoryUrlModal}
                    onSubmit={this.onSubmitCategoryUrl.bind(this)}
                    onClose={() => this.onToggleCategoryUrlModal(false)}
                />

                <LoadingModal isOpen={this.state.isLoading} />
            </Modal>
        )
    }
}

const linkGenerateMenu = (T, onClick) => (
    <Menu>
        <Menu.Item onClick={() => onClick('POST')}>
            {T('URL_FROM_ARTICLE_CATEGORY')}
        </Menu.Item>
        <Menu.Item onClick={() => onClick('PRODUCT')}>
            {T('URL_FROM_PRODUCT_CATEGORY')}
        </Menu.Item>
    </Menu>
)

const generateParentMenuList = (T, menuList) => {
    let options = [{ name: T('NONE'), index: '-1' }]
    menuList.forEach((menuLevel1, index1) => {
        options.push({ name: menuLevel1.title, index: `${index1}` })
        if (menuLevel1.submenus && menuLevel1.submenus.length > 0) {
            menuLevel1.submenus.forEach((menuLevel2, index2) => {
                options.push({
                    name: ' - ' + menuLevel2.title,
                    index: index1 + ',' + index2
                })
            })
        }
    })

    return options
}

const generateParentMenuKey = (indexList = []) => {
    let parentKey = '-1'
    let parentIndexs = [...indexList].slice(0, -1)
    if (parentIndexs.length > 0) {
        parentKey = parentIndexs.join(',')
    }
    return parentKey
}

export default MenuSettingModal
